export default {
	home: {
		name: ""
	},
	page_out_trade_no: "상점 주문 번호"
};
